<!-- PAGE CONTENT WRAPPER -->
<div class="page-content-wrap contentdata">
  <!--Chart content-->
  <div class="row common-page-contentwrap">
    <div class="col-md-12">
      <div [hidden]="pgLoad">
        <div class="adjust loader-container">
          <div class="loader2"></div>
        </div>
      </div>
      <!-- farm user tabs -->
      <!-- <div [hidden]="!pgLoad" class="row farmuserHeader">
        <div class="metricsList">
          <div class="panel panel-default framuserheaders">
            <div class="panel-body">
              <div class="btn-group btn-group-md">
                <button class="btn btn-primary framsbtn" type="button">Farms</button>
                <button class="btn btn-primary userbtn" type="button">User</button>
              </div>
              <div class="col-xs-12 col-md-6 business_name">
                <h4>{{loginUserBusinessName}}</h4>
              </div>
            </div>
          </div>
        </div>
      </div> -->
      <!-- farm user tabs End -->
      <!-- breadcrumb -->
      <div [hidden]="!pgLoad" class="row">
        <div class="col-md-12">
          <div class="page-breadcrumb">
           <ul class="page-breadcrumb__trail">
                <li><a>Metrics</a></li>
                <li><a>Water Quality</a></li>
              </ul>
            <div class="page-breadcrumb__icons">
              <a routerLink="/home"><img src="../../../../assets/images/New_Icons/home-transprent-icon.svg" title="Home"></a>
            </div>
          </div>
        </div>
      </div>
      <!-- breadcrumb End -->
      <div class="block" [hidden]="!pgLoad">
        <div class="screen_heading_div">
          <span>Water Quality</span>
        </div>
        <div class="metrics-cards_container row">
          <!-- Water Quality grid -->
          <div [hidden]="!pgLoad" class="row">
            <div [hidden]="!pgLoad" class="col-xs-12">
              <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6 fcr_chart">
                <div class="x_chart_panel   ">
                  <div class="x_chart_title">
                    <h2><strong>  {{charttitle}}</strong></h2>
                    <ul class="nav navbar-right chart_panel_toolbox">
                      <li><img src="../../../../../../assets/img/metrics_icons/piechart.svg" width="20px"
                               (click)="phgraphselection('doughnut')"
                               [ngClass]="phType == 'doughnut'?('colorblue'):('colorblack')" height="17px"/>
                      </li>
                      <li><img src="../../../../../../assets/img/metrics_icons/reports.svg" width="20px"
                               (click)="phgraphselection('bar')"
                               [ngClass]="phType == 'bar'?('colorblue'):('colorblack')" height="17px"/>
                      <li><img aria-hidden="true" data-toggle="modal" data-target="#pHModal" height="17px" width="20px"
                               (click)="getAllpHLocation()"
                               src="../../../../../../assets/img/metrics_icons/location.svg"/></li>
                      <!-- <li><img height="17px" src="../../../../../../assets/img/metrics_icons/list.svg" width="20px"/></li> -->
                    </ul>
                    <div class="clearfix"></div>
                  </div>
                  <div class="x_content">
                    <div id="canvasarea">
                      <canvas id="myChart"></canvas>
                    </div>
                  </div>
                </div>
              </div>
              <!--list-->
              <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6">
                <p class="panel panel-default x_chart_panel nodata"
                   *ngIf="waterQualityList && waterQualityList.length == 0"> No data found</p>
                <div class="panel panel-default" *ngIf="waterQualityList && waterQualityList.length > 0">
                  <div class="col-lg-12">
                    <div class="metrics-search_button_container">
                      <div class="search-div">
                        <img src="../../../../../../assets/images/New_Icons/search-icon.svg">
                        <input type="text" (keyup)="searchpHBusiness()" [(ngModel)]="pHsearch"
                               name="search" autocomplete="off" placeholder="search..">
                      </div>
                    </div>
                  </div>
                  <div class="panel-body table-responsive tablescroll">
                    <table class="table table-striped table-hover">
                      <thead>
                      <tr>
                        <th *ngIf="loginUserBusinessCategory != 'Farm'">Business Name</th>
                        <th>Pond Name</th>
                        <th>Section Name</th>
                        <th>PH</th>
                      </tr>
                      </thead>
                      <tbody>
                      <div [hidden]="responseLoad">
                        <div class="adjust">
                          <div class="loaderstyle loader2"></div>
                        </div>
                      </div>
                      <tr class="searchfunph" *ngFor="let list of waterQualityList">
                        <td *ngIf="loginUserBusinessCategory != 'Farm'">{{list && list.FarmSiteBusinessEntity[0] && list.FarmSiteBusinessEntity[0].businessID && list.FarmSiteBusinessEntity[0].businessID.businessName}}</td>
                        <td>{{list && list.name}}</td>
                        <td>{{(list && list.PondSection && list.PondSection.section_name == null) ? '--' : (list && list.PondSection && list.PondSection.section_name)}}</td>
                        <td
                          *ngFor="let parameter of list.readings">{{(parameter && parameter.pH == null) ? '--' : parameter && parameter.pH.toFixed(2)}}</td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <!--list-->
            </div>
          </div>
          <div [hidden]="!pgLoad" class="row">
            <div [hidden]="!pgLoad" class="col-xs-12">
              <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6 fcr_chart">
                <div class="x_chart_panel   ">
                  <div class="x_chart_title">
                    <h2><strong>  {{salinitycharttitle}}</strong></h2>
                    <ul class="nav navbar-right chart_panel_toolbox">
                      <li><img src="../../../../../../assets/img/metrics_icons/piechart.svg" width="20px"
                               (click)="salinitygraphselection('doughnut')"
                               [ngClass]="salinityType == 'doughnut'?('colorblue'):('colorblack')" height="17px"/>
                      </li>
                      <li><img src="../../../../../../assets/img/metrics_icons/reports.svg" width="20px"
                               (click)="salinitygraphselection('bar')"
                               [ngClass]="salinityType == 'bar'?('colorblue'):('colorblack')" height="17px"/>
                      <li><img aria-hidden="true" data-toggle="modal" data-target="#salinityModal" height="17px"
                               width="20px"
                               (click)="getAllSalinityLocation()"
                               src="../../../../../../assets/img/metrics_icons/location.svg"/></li>
                      <!-- <li><img height="17px" src="../../../../../../assets/img/metrics_icons/list.svg" width="20px"/></li> -->
                    </ul>
                    <div class="clearfix"></div>
                  </div>
                  <div class="x_content">
                    <div id="salinitycanvasarea">
                      <canvas id="salinityChart"></canvas>
                    </div>
                  </div>
                </div>
              </div>
              <!--list-->
              <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6">
                <p class="panel panel-default x_chart_panel nodata"
                   *ngIf="waterQualityList && waterQualityList.length == 0"> No data found</p>
                <div class="panel panel-default" *ngIf="waterQualityList && waterQualityList.length > 0">
                  <div class="col-lg-12">
                    <div class="metrics-search_button_container">
                      <div class="search-div">
                        <img src="../../../../../../assets/images/New_Icons/search-icon.svg">
                        <input type="text" (keyup)="searchSalinityBusiness()" [(ngModel)]="salinitysearch"
                               name="search" autocomplete="off" placeholder="search..">
                      </div>
                    </div>
                  </div>
                  <div class="panel-body table-responsive tablescroll">
                    <table class="table table-striped table-hover">
                      <thead>
                      <tr>
                        <th *ngIf="loginUserBusinessCategory != 'Farm'">Business Name</th>
                        <th>Pond Name</th>
                        <th>Section Name</th>
                        <th>Salinity</th>
                      </tr>
                      </thead>
                      <tbody>
                      <div [hidden]="responseLoad">
                        <div class="adjust">
                          <div class="loaderstyle loader2"></div>
                        </div>
                      </div>
                      <tr class="searchfunsalinity" *ngFor="let list of waterQualityList">
                        <td *ngIf="loginUserBusinessCategory != 'Farm'">{{list && list.FarmSiteBusinessEntity[0] && list.FarmSiteBusinessEntity[0].businessID && list.FarmSiteBusinessEntity[0].businessID.businessName}}</td>
                        <td>{{list && list.name}}</td>
                        <td>{{(list && list.PondSection && list.PondSection.section_name == null) ? '--' : (list && list.PondSection && list.PondSection.section_name)}}</td>
                        <td
                          *ngFor="let parameter of list.readings">{{(parameter && parameter.salinity == null) ? '--' : parameter && parameter.salinity.toFixed(2)}}</td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>

            </div>
          </div>
          <div [hidden]="!pgLoad" class="row">
            <div [hidden]="!pgLoad" class="col-xs-12">
              <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6 fcr_chart">
                <div class="x_chart_panel   ">
                  <div class="x_chart_title">
                    <h2><strong>  {{docharttitle}}</strong></h2>
                    <ul class="nav navbar-right chart_panel_toolbox">
                      <li><img src="../../../../../../assets/img/metrics_icons/piechart.svg" width="20px"
                               (click)="dographselection('doughnut')" class=""
                               [ngClass]="doType == 'doughnut'?('colorblue'):('colorblack')" height="17px"/>
                      </li>
                      <li><img src="../../../../../../assets/img/metrics_icons/reports.svg" width="20px"
                               (click)="dographselection('bar')"
                               [ngClass]="doType == 'bar'?('colorblue'):('colorblack')" height="17px"/>
                      <li><img aria-hidden="true" data-toggle="modal" data-target="#doModal" height="17px" width="20px"
                               (click)="getAllDoLocation()"
                               src="../../../../../../assets/img/metrics_icons/location.svg"/></li>
                      <!-- <li><img height="17px" src="../../../../../../assets/img/metrics_icons/list.svg" width="20px"/></li> -->
                    </ul>
                    <div class="clearfix"></div>
                  </div>
                  <div class="x_content">
                    <div id="docanvasarea">
                      <canvas id="doChart"></canvas>
                    </div>
                  </div>
                </div>
              </div>

              <!--list-->
              <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6">
                <p class="panel panel-default x_chart_panel nodata"
                   *ngIf="waterQualityList && waterQualityList.length == 0"> No data found</p>
                <div class="panel panel-default" *ngIf="waterQualityList && waterQualityList.length > 0">
                  <div class="col-lg-12">
                    <div class="metrics-search_button_container">
                      <div class="search-div">
                        <img src="../../../../../../assets/images/New_Icons/search-icon.svg">
                        <input type="text" (keyup)="searchDOBusiness()" [(ngModel)]="dosearch"
                               name="search" autocomplete="off" placeholder="search..">
                      </div>
                    </div>
                  </div>
                  <div class="panel-body table-responsive tablescroll">
                    <table class="table table-striped table-hover">
                      <thead>
                      <tr>
                        <th *ngIf="loginUserBusinessCategory != 'Farm'">Business Name</th>
                        <th>Pond Name</th>
                        <th>Section Name</th>
                        <th>DO</th>
                      </tr>
                      </thead>
                      <tbody>
                      <div [hidden]="responseLoad">
                        <div class="adjust">
                          <div class="loaderstyle loader2"></div>
                        </div>
                      </div>
                      <tr class="searchfundo" *ngFor="let list of waterQualityList">
                        <td *ngIf="loginUserBusinessCategory != 'Farm'">{{list && list.FarmSiteBusinessEntity[0] && list.FarmSiteBusinessEntity[0].businessID && list.FarmSiteBusinessEntity[0].businessID.businessName}}</td>
                        <td>{{list && list.name}}</td>
                        <td>{{(list && list.PondSection && list.PondSection.section_name == null) ? '--' : (list && list.PondSection && list.PondSection.section_name)}}</td>
                        <td
                          *ngFor="let parameter of list.readings">{{(parameter && parameter.do2 == null) ? '--' : (parameter && parameter.do2.toFixed(2))}}</td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>

            </div>
          </div>
          <div [hidden]="!pgLoad" class="row">
            <div [hidden]="!pgLoad" class="col-xs-12">
              <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6 fcr_chart">
                <div class="x_chart_panel   ">
                  <div class="x_chart_title">
                    <h2><strong>  {{tempcharttitle}}</strong></h2>
                    <ul class="nav navbar-right chart_panel_toolbox">
                      <li><img src="../../../../../../assets/img/metrics_icons/piechart.svg" width="20px"
                               (click)="tempgraphselection('doughnut')"
                               [ngClass]="tempType == 'doughnut'?('colorblue'):('colorblack')" height="17px"/>
                      </li>
                      <li><img src="../../../../../../assets/img/metrics_icons/reports.svg" width="20px"
                               (click)="tempgraphselection('bar')"
                               [ngClass]="tempType == 'bar'?('colorblue'):('colorblack')" height="17px"/>
                      <li><img aria-hidden="true" data-toggle="modal" data-target="#tempModal" height="17px"
                               width="20px"
                               (click)="getAllTempLocation()"
                               src="../../../../../../assets/img/metrics_icons/location.svg"/></li>
                      <!-- <li><img height="17px" src="../../../../../../assets/img/metrics_icons/list.svg" width="20px"/></li> -->
                    </ul>
                    <div class="clearfix"></div>
                  </div>
                  <div class="x_content">
                    <div id="tempcanvasarea">
                      <canvas id="tempChart"></canvas>
                    </div>
                  </div>
                </div>
              </div>

              <!--list-->
              <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6">
                <p class="panel panel-default x_chart_panel nodata"
                   *ngIf="waterQualityList && waterQualityList.length == 0"> No data found</p>
                <div class="panel panel-default" *ngIf="waterQualityList && waterQualityList.length > 0">
                  <div class="col-lg-12">
                    <div class="metrics-search_button_container">
                      <div class="search-div">
                        <img src="../../../../../../assets/images/New_Icons/search-icon.svg">
                        <input type="text" (keyup)="searchTempBusiness()" [(ngModel)]="tempsearch"
                               name="search" autocomplete="off" placeholder="search..">
                      </div>
                    </div>
                  </div>
                  <div class="panel-body table-responsive tablescroll">
                    <table class="table table-striped table-hover">
                      <thead>
                      <tr>
                        <th *ngIf="loginUserBusinessCategory != 'Farm'">Business Name</th>
                        <th>Pond Name</th>
                        <th>Section Name</th>
                        <th>Temperature</th>
                      </tr>
                      </thead>
                      <tbody>
                      <div [hidden]="responseLoad">
                        <div class="adjust">
                          <div class="loaderstyle loader2"></div>
                        </div>
                      </div>
                      <tr class="searchfuntemp" *ngFor="let list of waterQualityList">
                        <td *ngIf="loginUserBusinessCategory != 'Farm'">{{list && list.FarmSiteBusinessEntity[0] && list.FarmSiteBusinessEntity[0].businessID && list.FarmSiteBusinessEntity[0].businessID.businessName}}</td>
                        <td>{{list && list.name}}</td>
                        <td>{{(list && list.PondSection && list.PondSection.section_name == null) ? '--' : (list && list.PondSection && list.PondSection.section_name)}}</td>
                        <td
                          *ngFor="let parameter of list.readings">{{(parameter && parameter.temperature == null) ? '--' : parameter && parameter.temperature.toFixed(2)}}</td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <!--list-->
            </div>
          </div>
          <div [hidden]="!pgLoad" class="row">
            <div [hidden]="!pgLoad" class="col-xs-12">
              <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6 fcr_chart">
                <div class="x_chart_panel   ">
                  <div class="x_chart_title">
                    <h2><strong>  {{alkalinitycharttitle}}</strong></h2>
                    <ul class="nav navbar-right chart_panel_toolbox">
                      <li><img src="../../../../../../assets/img/metrics_icons/piechart.svg" width="20px"
                               (click)="alkalinitygraphselection('doughnut')"
                               [ngClass]="alkalinityType == 'doughnut'?('colorblue'):('colorblack')" height="17px"/>
                      </li>
                      <li><img src="../../../../../../assets/img/metrics_icons/reports.svg" width="20px"
                               (click)="alkalinitygraphselection('bar')"
                               [ngClass]="alkalinityType == 'bar'?('colorblue'):('colorblack')" height="17px"/>
                      <li><img aria-hidden="true" data-toggle="modal" data-target="#alkalinityModal" height="17px"
                               width="20px"
                               (click)="getAllAlkalinityLocation()"
                               src="../../../../../../assets/img/metrics_icons/location.svg"/></li>
                      <!-- <li><img height="17px" src="../../../../../../assets/img/metrics_icons/list.svg" width="20px"/> </li> -->
                    </ul>
                    <div class="clearfix"></div>
                  </div>
                  <div class="x_content">
                    <div id="alkalinitycanvasarea">
                      <canvas id="alkalinityChart"></canvas>
                    </div>
                  </div>
                </div>
              </div>

              <!--list-->
              <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6">
                <p class="panel panel-default x_chart_panel nodata"
                   *ngIf="waterQualityList && waterQualityList.length == 0"> No data found</p>
                <div class="panel panel-default" *ngIf="waterQualityList && waterQualityList.length > 0">
                  <div class="col-lg-12">
                    <div class="metrics-search_button_container">
                      <div class="search-div">
                        <img src="../../../../../../assets/images/New_Icons/search-icon.svg">
                        <input type="text" (keyup)="searchAlkalinityBusiness()" [(ngModel)]="alkalinitysearch"
                               name="search" autocomplete="off" placeholder="search..">
                      </div>
                    </div>
                  </div>
                  <div class="panel-body table-responsive tablescroll">
                    <table class="table table-striped table-hover">
                      <thead>
                      <tr>
                        <th *ngIf="loginUserBusinessCategory != 'Farm'">Business Name</th>
                        <th>Pond Name</th>
                        <th>Section Name</th>
                        <th>Alkalinity</th>
                      </tr>
                      </thead>
                      <tbody>
                      <div [hidden]="responseLoad">
                        <div class="adjust">
                          <div class="loaderstyle loader2"></div>
                        </div>
                      </div>
                      <tr class="searchfunalkalinity" *ngFor="let list of waterQualityList">
                        <td *ngIf="loginUserBusinessCategory != 'Farm'">{{list && list.FarmSiteBusinessEntity[0] && list.FarmSiteBusinessEntity[0].businessID && list.FarmSiteBusinessEntity[0].businessID.businessName}}</td>
                        <td>{{list && list.name}}</td>
                        <td>{{(list && list.PondSection && list.PondSection.section_name == null) ? '--' : (list && list.PondSection && list.PondSection.section_name)}}</td>
                        <td
                          *ngFor="let parameter of list.readings">{{(parameter && parameter.alkalinity == null) ? '--' : (parameter && parameter.alkalinity)}}</td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>

            </div>
          </div>
          <div [hidden]="!pgLoad" class="row">
            <div [hidden]="!pgLoad" class="col-xs-12">
              <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6 fcr_chart">
                <div class="x_chart_panel   ">
                  <div class="x_chart_title">
                    <h2><strong>  {{turbiditycharttitle}}</strong></h2>
                    <ul class="nav navbar-right chart_panel_toolbox">
                      <li><img src="../../../../../../assets/img/metrics_icons/piechart.svg" width="20px"
                               (click)="turbiditygraphselection('doughnut')"
                               [ngClass]="turbidityType == 'doughnut'?('colorblue'):('colorblack')" height="17px"/>
                      </li>
                      <li><img src="../../../../../../assets/img/metrics_icons/reports.svg" width="20px"
                               (click)="turbiditygraphselection('bar')"
                               [ngClass]="turbidityType == 'bar'?('colorblue'):('colorblack')" height="17px"/>
                      <li><img aria-hidden="true" data-toggle="modal" data-target="#turbidityModal" height="17px"
                               width="20px"
                               (click)="getAllTurbidityLocation()"
                               src="../../../../../../assets/img/metrics_icons/location.svg"/></li>
                      <!-- <li><img height="17px" src="../../../../../../assets/img/metrics_icons/list.svg" width="20px"/></li> -->
                    </ul>
                    <div class="clearfix"></div>
                  </div>
                  <div class="x_content">
                    <div id="turbiditycanvasarea">
                      <canvas id="turbidityChart"></canvas>
                    </div>
                  </div>
                </div>
              </div>

              <!--list-->
              <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6">
                <p class="panel panel-default x_chart_panel nodata"
                   *ngIf="waterQualityList && waterQualityList.length == 0"> No data found</p>
                <div class="panel panel-default" *ngIf="waterQualityList && waterQualityList.length > 0">
                  <div class="col-lg-12">
                    <div class="metrics-search_button_container">
                      <div class="search-div">
                        <img src="../../../../../../assets/images/New_Icons/search-icon.svg">
                        <input type="text" (keyup)="searchTurbidityBusiness()" [(ngModel)]="turbiditysearch"
                               name="search" autocomplete="off" placeholder="search..">
                      </div>
                    </div>
                  </div>
                  <div class="panel-body table-responsive tablescroll">
                    <table class="table table-striped table-hover">
                      <thead>
                      <tr>
                        <th *ngIf="loginUserBusinessCategory != 'Farm'">Business Name</th>
                        <th>Pond Name</th>
                        <th>Section Name</th>
                        <th>Turbidity</th>
                      </tr>
                      </thead>
                      <tbody>
                      <div [hidden]="responseLoad">
                        <div class="adjust">
                          <div class="loaderstyle loader2"></div>
                        </div>
                      </div>
                      <tr class="searchfunturbidity" *ngFor="let list of waterQualityList">
                        <td *ngIf="loginUserBusinessCategory != 'Farm'">{{list && list.FarmSiteBusinessEntity[0] && list.FarmSiteBusinessEntity[0].businessID && list.FarmSiteBusinessEntity[0].businessID.businessName}}</td>
                        <td>{{list && list.name}}</td>
                        <td>{{(list && list.PondSection && list.PondSection.section_name == null) ? '--' : (list && list.PondSection && list.PondSection.section_name)}}</td>
                        <td
                          *ngFor="let parameter of list.readings">{{(parameter && parameter.turbidity == null) ? '--' : (parameter && parameter.turbidity.toFixed(2))}}</td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
      <!-- End Water Quality -->
      <!-- pH Location details-->
      <div class="modal fade" id="pHModal" role="dialog" *ngIf="pHLocations && pHLocations.length>0">
        <div class="modal-dialog active_location">
          <!-- Modal content-->
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close close_btn" data-dismiss="modal"  title="Close Popup">&times;</button>
              <h4 class="modal-title location_heading">pH Location View</h4>
            </div>
            <div class="modal-body location_data  totalfarmermodelscrollbar" id="style-4">
              <div *ngFor="let location of pHLocations" class="row">
                <div class="col-xs-12 location_state">
                  <p>{{location.state}}</p>
                </div>
                <div *ngFor="let village of location.data" class="doc_details col-lg-12">
                  <div class="col-xs-9 doc_villagename">
                    <!--<span>{{village.district}},</span>&nbsp;&nbsp;--><span>{{village.village}}</span>
                  </div>
                  <div class="col-xs-3 doc_pondcount">
                    <p class="pull-right">{{village.count}} Pond(s)</p>
                  </div>
                  <div class="row">
                    <div class="col-xs-12 col-sm-2 col-md-2 doc_cards">
                      <h3 class="doc_heading">UA</h3>
                      <h3 class="pull-right doc_count">{{village.undefinedCount}}</h3>
                    </div>
                    <div class="col-xs-12 col-sm-2 col-md-2 doc_cards">
                      <h3 class="doc_heading"><span>&#8804;</span> 6</h3>
                      <h3 class="pull-right doc_count">{{village.less_than_six}}</h3>
                    </div>
                    <div class="col-xs-12 col-sm-2 col-md-2 doc_cards">
                      <h3 class="doc_heading">6.1 - 7.5</h3>
                      <h3 class="pull-right doc_count">{{village.six_sevenPointFive_count}}</h3>
                    </div>
                    <div class="col-xs-12 col-sm-2 col-md-2 doc_cards">
                      <h3 class="doc_heading">7.6 - 8.5</h3>
                      <h3 class="pull-right doc_count">{{village.sevenPointFive_eightPointFive_count}}</h3>
                    </div>
                    <div class="col-xs-12 col-sm-2 col-md-2 doc_cards">
                      <h3 class="doc_heading">8.6 - 9</h3>
                      <h3 class="pull-right doc_count">{{village.eightPointFive_nine_count}}</h3>
                    </div>
                    <div class="col-xs-12 col-sm-2 col-md-2 doc_cards">
                      <h3 class="doc_heading">> 9</h3>
                      <h3 class="pull-right doc_count">{{village.greater_than_nine}}</h3>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer ambrolive-popup-close">
              <button class="center-block submitbtn" data-dismiss="modal"
                      type="submit"><img src="assets/images/New_Icons/close.svg">Close
              </button>
            </div>
          </div>

        </div>
      </div>
      <!-- pH Location details end -->
      <!-- salinity Location details-->
      <div class="modal fade" id="salinityModal" role="dialog" *ngIf="salinityLocations && salinityLocations.length>0">
        <div class="modal-dialog active_location">
          <!-- Modal content-->
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close close_btn" data-dismiss="modal"  title="Close Popup">&times;</button>
              <h4 class="modal-title location_heading">Salinity Location View</h4>
            </div>
            <div class="modal-body location_data  totalfarmermodelscrollbar" id="style-4">
              <div *ngFor="let location of salinityLocations" class="row">
                <div class="col-xs-12 location_state">
                  <p>{{location.state}}</p>
                </div>
                <div *ngFor="let village of location.data" class="doc_details col-lg-12">
                  <div class="col-xs-9 doc_villagename">
                    <!--<span>{{village.district}},</span>&nbsp;&nbsp;--><span>{{village.village}}</span>
                  </div>
                  <div class="col-xs-3 doc_pondcount">
                    <p class="pull-right">{{village.count}} Pond(s)</p>
                  </div>
                  <div class="row">
                    <div class="col-xs-12 col-sm-2 col-md-2 doc_cards">
                      <h3 class="doc_heading">UA</h3>
                      <h3 class="pull-right doc_count">{{village.undefinedCount}}</h3>
                    </div>
                    <div class="col-xs-12 col-sm-2 col-md-2 doc_cards">
                      <h3 class="doc_heading"><span>&#8804;</span> 5</h3>
                      <h3 class="pull-right doc_count">{{village.less_than_five}}</h3>
                    </div>
                    <div class="col-xs-12 col-sm-2 col-md-2 doc_cards">
                      <h3 class="doc_heading">6 - 15</h3>
                      <h3 class="pull-right doc_count">{{village.five_fifteen_count}}</h3>
                    </div>
                    <div class="col-xs-12 col-sm-2 col-md-2 doc_cards">
                      <h3 class="doc_heading">16 - 25</h3>
                      <h3 class="pull-right doc_count">{{village.fifteen_twentyFive_count}}</h3>
                    </div>
                    <div class="col-xs-12 col-sm-2 col-md-2 doc_cards">
                      <h3 class="doc_heading">26 - 30</h3>
                      <h3 class="pull-right doc_count">{{village.twentyFive_thirty_count}}</h3>
                    </div>
                    <div class="col-xs-12 col-sm-2 col-md-2 doc_cards">
                      <h3 class="doc_heading"> > 30</h3>
                      <h3 class="pull-right doc_count">{{village.greater_than_thirty}}</h3>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer ambrolive-popup-close">
              <button class="center-block submitbtn" data-dismiss="modal"
                      type="submit"><img src="assets/images/New_Icons/close.svg">Close
              </button>
            </div>
          </div>

        </div>
      </div>
      <!-- salinity Location details end -->
      <!-- DO Location details-->
      <div class="modal fade" id="doModal" role="dialog" *ngIf="doLocations && doLocations.length>0">
        <div class="modal-dialog active_location">
          <!-- Modal content-->
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close close_btn" data-dismiss="modal"  title="Close Popup">&times;</button>
              <h4 class="modal-title location_heading">Ponds by Do2 Location View</h4>
            </div>
            <div class="modal-body location_data  totalfarmermodelscrollbar" id="style-4">
              <div *ngFor="let location of doLocations" class="row">
                <div class="col-xs-12 location_state">
                  <p>{{location.state}}</p>
                </div>
                <div *ngFor="let village of location.data" class="doc_details col-lg-12">
                  <div class="col-xs-9 doc_villagename">
                    <!--<span>{{village.district}},</span>&nbsp;--><span>{{village.village}}</span>
                  </div>
                  <div class="col-xs-3 doc_pondcount">
                    <p class="pull-right">{{village.count}} Pond(s)</p>
                  </div>
                  <div class="row">
                    <div class="col-xs-12 col-sm-2 col-md-2 doc_cards">
                      <h3 class="doc_heading">UA</h3>
                      <h3 class="pull-right doc_count">{{village.undefinedCount}}</h3>
                    </div>
                    <div class="col-xs-12 col-sm-2 col-md-2 doc_cards">
                      <h3 class="doc_heading"><span>&#8804;</span> 2</h3>
                      <h3 class="pull-right doc_count">{{village.less_than_two}}</h3>
                    </div>
                    <div class="col-xs-12 col-sm-2 col-md-2 doc_cards">
                      <h3 class="doc_heading">3 - 4</h3>
                      <h3 class="pull-right doc_count">{{village.two_four_count}}</h3>
                    </div>
                    <div class="col-xs-12 col-sm-2 col-md-2 doc_cards">
                      <h3 class="doc_heading">5 - 8</h3>
                      <h3 class="pull-right doc_count">{{village.four_eight_count}}</h3>
                    </div>
                    <div class="col-xs-12 col-sm-2 col-md-2 doc_cards">
                      <h3 class="doc_heading">9 - 12</h3>
                      <h3 class="pull-right doc_count">{{village.eight_twelve_count}}</h3>
                    </div>
                    <div class="col-xs-12 col-sm-2 col-md-2 doc_cards">
                      <h3 class="doc_heading"> > 12</h3>
                      <h3 class="pull-right doc_count">{{village.greater_than_twelve}}</h3>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer ambrolive-popup-close">
              <button class="center-block submitbtn" data-dismiss="modal"
                      type="submit"><img src="assets/images/New_Icons/close.svg">Close
              </button>
            </div>
          </div>

        </div>
      </div>
      <!-- Pond by DO Location details end -->
      <!-- Temperature Location details-->
      <div class="modal fade" id="tempModal" role="dialog" *ngIf="tempratureLocations && tempratureLocations.length>0">
        <div class="modal-dialog active_location">
          <!-- Modal content-->
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close close_btn" data-dismiss="modal"  title="Close Popup">&times;</button>
              <h4 class="modal-title location_heading">Temperature Location View</h4>
            </div>
            <div class="modal-body location_data  totalfarmermodelscrollbar" id="style-4">
              <div *ngFor="let location of tempratureLocations" class="row">
                <div class="col-xs-12 location_state">
                  <p>{{location.state}}</p>
                </div>
                <div *ngFor="let village of location.data" class="doc_details col-lg-12">
                  <div class="col-xs-9 doc_villagename">
                    <!--<span>{{village.district}},</span>&nbsp;--><span>{{village.village}}</span>
                  </div>
                  <div class="col-xs-3 doc_pondcount">
                    <p class="pull-right">{{village.count}} Pond(s)</p>
                  </div>
                  <div class="row">
                    <div class="col-xs-12 col-sm-2 col-md-2 doc_cards">
                      <h3 class="doc_heading">UA</h3>
                      <h3 class="pull-right doc_count">{{village.undefinedCount}}</h3>
                    </div>
                    <div class="col-xs-12 col-sm-2 col-md-2 doc_cards">
                      <h3 class="doc_heading"><span>&#8804;</span> 22</h3>
                      <h3 class="pull-right doc_count">{{village.less_than_twentyTwo}}</h3>
                    </div>
                    <div class="col-xs-12 col-sm-2 col-md-2 doc_cards">
                      <h3 class="doc_heading">23 - 24</h3>
                      <h3 class="pull-right doc_count">{{village.twentyTwo_twentyFour_count}}</h3>
                    </div>
                    <div class="col-xs-12 col-sm-2 col-md-2 doc_cards">
                      <h3 class="doc_heading">25 - 26</h3>
                      <h3 class="pull-right doc_count">{{village.twentyFour_twentySix_count}}</h3>
                    </div>
                    <div class="col-xs-12 col-sm-2 col-md-2 doc_cards">
                      <h3 class="doc_heading">27 - 30</h3>
                      <h3 class="pull-right doc_count">{{village.twentySix_thirty_count}}</h3>
                    </div>
                    <div class="col-xs-12 col-sm-2 col-md-2 doc_cards">
                      <h3 class="doc_heading">> 30</h3>
                      <h3 class="pull-right doc_count">{{village.greater_than_thirty}}</h3>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer ambrolive-popup-close">
              <button class="center-block submitbtn" data-dismiss="modal"
                      type="submit"><img src="assets/images/New_Icons/close.svg">Close
              </button>
            </div>
          </div>
        </div>
      </div>
      <!-- Temperature Location details end -->
      <!-- Alkalinity Location details-->
      <div class="modal fade" id="alkalinityModal" role="dialog"
           *ngIf="alkalinityLocations && alkalinityLocations.length>0">
        <div class="modal-dialog active_location">
          <!-- Modal content-->
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close close_btn" data-dismiss="modal"  title="Close Popup">&times;</button>
              <h4 class="modal-title location_heading">Alkalinity Location View</h4>
            </div>
            <div class="modal-body location_data  totalfarmermodelscrollbar" id="style-4">
              <div *ngFor="let location of alkalinityLocations" class="row">
                <div class="col-xs-12 location_state">
                  <p>{{location.state}}</p>
                </div>
                <div *ngFor="let village of location.data" class="doc_details col-lg-12">
                  <div class="col-xs-9 doc_villagename">
                    <!--<span>{{village.district}},</span>&nbsp;--><span>{{village.village}}</span>
                  </div>
                  <div class="col-xs-3 doc_pondcount">
                    <p class="pull-right">{{village.count}} Pond(s)</p>
                  </div>
                  <div class="row">
                    <div class="col-xs-12 col-sm-2 col-md-2 doc_cards">
                      <h3 class="doc_heading">UA</h3>
                      <h3 class="pull-right doc_count">{{village.undefinedCount}}</h3>
                    </div>
                    <div class="col-xs-12 col-sm-2 col-md-2 doc_cards">
                      <h3 class="doc_heading">0 - 150</h3>
                      <h3 class="pull-right doc_count">{{village.less_than_oneFifty}}</h3>
                    </div>
                    <div class="col-xs-12 col-sm-2 col-md-2 doc_cards">
                      <h3 class="doc_heading">151 - 200</h3>
                      <h3 class="pull-right doc_count">{{village.oneFifty_twoHundred_count}}</h3>
                    </div>
                    <div class="col-xs-12 col-sm-2 col-md-2 doc_cards">
                      <h3 class="doc_heading">201 - 250</h3>
                      <h3 class="pull-right doc_count">{{village.twoHundred_twoFifty_count}}</h3>
                    </div>
                    <div class="col-xs-12 col-sm-2 col-md-2 doc_cards">
                      <h3 class="doc_heading">251 - 300</h3>
                      <h3 class="pull-right doc_count">{{village.twoFifty_threeHundred_count}}</h3>
                    </div>
                    <div class="col-xs-12 col-sm-2 col-md-2 doc_cards">
                      <h3 class="doc_heading">> 300</h3>
                      <h3 class="pull-right doc_count">{{village.greater_than_threeHundred}}</h3>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer ambrolive-popup-close">
              <button class="center-block submitbtn" data-dismiss="modal"
                      type="submit"><img src="assets/images/New_Icons/close.svg">Close
              </button>
            </div>
          </div>
        </div>
      </div>
      <!-- Alkalinity Location details end -->
      <!-- Turbidity Location details-->
      <div class="modal fade" id="turbidityModal" role="dialog"
           *ngIf="turbidityLocations && turbidityLocations.length>0">
        <div class="modal-dialog active_location">
          <!-- Modal content-->
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close close_btn" data-dismiss="modal" title="Close Popup">&times;</button>
              <h4 class="modal-title location_heading">Turbidity Location View</h4>
            </div>
            <div class="modal-body location_data  totalfarmermodelscrollbar" id="style-4">
              <div *ngFor="let location of turbidityLocations" class="row">
                <div class="col-xs-12 location_state">
                  <p>{{location.state}}</p>
                </div>
                <div *ngFor="let village of location.data" class="doc_details col-lg-12">
                  <div class="col-xs-9 doc_villagename">
                    <!--<span>{{village.district}},</span>&nbsp;--><span>{{village.village}}</span>
                  </div>
                  <div class="col-xs-3 doc_pondcount">
                    <p class="pull-right">{{village.count}} Pond(s)</p>
                  </div>
                  <div class="row">
                    <div class="col-xs-12 col-sm-2 col-md-2 doc_cards">
                      <h3 class="doc_heading">UA</h3>
                      <h3 class="pull-right doc_count">{{village.undefinedCount}}</h3>
                    </div>
                    <div class="col-xs-12 col-sm-2 col-md-2 doc_cards">
                      <h3 class="doc_heading">0 - 12</h3>
                      <h3 class="pull-right doc_count">{{village.less_than_twelve}}</h3>
                    </div>
                    <div class="col-xs-12 col-sm-2 col-md-2 doc_cards">
                      <h3 class="doc_heading">13 - 15</h3>
                      <h3 class="pull-right doc_count">{{village.twelve_fifteen_count}}</h3>
                    </div>
                    <div class="col-xs-12 col-sm-2 col-md-2 doc_cards">
                      <h3 class="doc_heading">16 - 30</h3>
                      <h3 class="pull-right doc_count">{{village.fifteen_thirty_count}}</h3>
                    </div>
                    <div class="col-xs-12 col-sm-2 col-md-2 doc_cards">
                      <h3 class="doc_heading">31 - 80</h3>
                      <h3 class="pull-right doc_count">{{village.thirty_eighty_count}}</h3>
                    </div>
                    <div class="col-xs-12 col-sm-2 col-md-2 doc_cards">
                      <h3 class="doc_heading">> 80</h3>
                      <h3 class="pull-right doc_count">{{village.greater_than_eighty}}</h3>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer ambrolive-popup-close">
              <button class="center-block submitbtn" data-dismiss="modal"
                      type="submit"><img src="assets/images/New_Icons/close.svg">Close
              </button>
            </div>
          </div>
        </div>
      </div>
      <!-- Turbidity Location details end -->
    </div>
  </div>
</div>
